<template>
  <qingsuTop
    class="qingsu-free-top"
    :brandData="brandData"
    :showYxlLogo="false"
    :showRuleBtn="!!brandData.service_introduction"
    :block="block"
    :bannerAutoHeight="true"
    :progressNum="progressNum"
    :isShowEntry="false"
    @showRule="showRule"
    @linkClick="linkClick"
    @getNavbarHeight="h => $emit('getNavbarHeight', h)"
  >
    <div
      v-if="isApp"
      :class="['qingsu-free-share-btn', scrollDirection]"
      @click="handleShare"
    >
      分享给<br />关心的人
    </div>
    <template v-if="brandData.share_poster">
      <transition name="transition-fade">
        <div
          class="qingsu-free-share-img-model"
          v-show="isShowModel"
          @touchmove.prevent
        >
          <div class="icon" @click="isShowModel = false">
            <icon name="m-close1" />
          </div>
          <div class="img"><img :src="brandData.share_poster" /></div>
          <div class="msg">- 长按保存图片，分享给关心的人 -</div>
        </div>
      </transition>
    </template>
    <pneumoniaRule
      v-model="isShowRule"
      :rule="brandData.service_introduction"
    />
  </qingsuTop>
</template>

<script>
import pneumoniaRule from 'component/qingsu/pneumoniaRule.vue'
import qingsuTop from './qingsuTop'
export default {
  data() {
    return {
      isShowModel: false,
      isShowRule: false
    }
  },
  components: {
    pneumoniaRule,
    qingsuTop
  },
  props: {
    progressNum: {
      type: Number,
      default: 0
    }
  },
  // mounted() {
  //   this.$store.dispatch('qingsuindex/fetchFreeQingsuPoster', this.$route.query)
  // },
  computed: {
    yixinliLogo() {
      return {
        id: '8955',
        img: `https://ossimg.xinli001.com/20190724/cd2c3853c483ae18128e2358dbf423f2.jpeg`,
        url: '',
        title: '壹心理',
        object_name: 'static'
      }
    },
    block() {
      return this.$store.state.qingsuchannel.ads
    },
    brandData() {
      return this.$store.state.qingsuchannel.index.channel_page_info
    },
    isApp() {
      return this.$platform.isYixinliApp
    }
  },
  methods: {
    showRule() {
      this.isShowRule = true
    },
    linkClick(item) {
      this.toAdPage(item)
    },
    handleShare() {
      if (this.brandData.share_poster) {
        this.isShowModel = true
      } else {
        this.$toast('请点击右上角分享～')
      }
    }
  }
}
</script>

<style lang="scss">
.qingsu-free-top {
  .qingsu-free-share-btn {
    position: fixed;
    right: 0;
    bottom: 300px;
    background: #ff745b;
    box-shadow: 0 2px 4px 0 rgba(138, 138, 138, 0.5);
    border-radius: 62px 0px 0px 62px;
    width: 130px;
    height: 80px;
    border-radius: 50px 0 0 50px;
    font-size: 24px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
    line-height: 28px;
    text-align: center;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 8px;
    box-sizing: border-box;
    transition: transform 0.5s;
    z-index: 2;
    &.up {
      transform: translate3d(100%, 0, 0);
    }
  }

  .qingsu-free-share-img-model {
    z-index: $modelZIndex;
    display: flex;
    background: rgba(0, 0, 0, 0.7);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    $w: 550px;
    .img {
      width: $w;
      // height: 750 * 1334 / $w;
    }
    .msg {
      font-size: 30px;
      line-height: 1.5;
      padding-top: 20px;
    }
    .icon {
      width: $w;
      height: 76px;
    }
    .icon-node-website {
      font-size: 56px;
      float: right;
      margin-right: -40px;
    }
  }
}
</style>
